import classNames from 'classnames';
import { PropsWithChildren } from 'react';

interface ModalProps extends PropsWithChildren {
  open: boolean;
  wide?: boolean;
  closeOnClickOutside?: boolean;
  onClose: () => void;
}

export default function Modal({
  open,
  closeOnClickOutside = true,
  wide = false,
  onClose,
  children,
}: ModalProps) {
  return (
    <>
      {open ? (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
            <div
              className="fixed inset-0 bg-neutral-800 opacity-25"
              onClick={() => {
                if (closeOnClickOutside) {
                  onClose();
                }
              }}
            />
            <div className={classNames('relative mx-auto my-6 w-auto', !wide && 'max-w-3xl')}>
              {/* content*/}
              <div className="relative flex max-h-[90vh] w-full flex-col overflow-y-auto rounded-lg border-0 bg-white shadow-lg outline-none focus:outline-none">
                <div className="p-5">{children}</div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
}
